import React, { Fragment } from 'react';
import moment from 'moment-timezone';
import { I18n, Translate } from 'react-redux-i18n';

import AnalyticsServer from '../../../app/server/analytics';
import {
  AnalyticsBarList,
  AnalyticsKpiGrid,
  AnalyticsPanel,
} from './AnalyticsVisuals';

const TZ = 'America/Santiago';

class LiveTab extends React.PureComponent {
  state = {
    loading: false,
    data: null,
    errorMessage: '',
  };

  componentDidMount() {
    this.fetchLive();
  }

  fetchLive = async () => {
    this.setState({ loading: true, errorMessage: '' });

    try {
      const data = await AnalyticsServer.getLive();
      this.setState({
        data,
        loading: false,
        errorMessage: data && data.error ? (data.message || data.error) : '',
      });
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      this.setState({
        data: null,
        loading: false,
        errorMessage: (error && error.message) || I18n.t('unknownError'),
      });
    }
  };

  renderTopPages = (topPages) => {
    if (!topPages || !topPages.length) {
      return (
        <div className="analytics-empty">
          <p>
            <Translate value="analyticsEmptyLive" />
          </p>
        </div>
      );
    }

    return (
      <AnalyticsPanel titleKey="analyticsTopPages">
        <AnalyticsBarList
          rows={topPages.map((row) => ({
            key: row.pagePath,
            label: row.pagePath,
            value: row.activeUsers,
          }))}
          emptyKey="analyticsEmptyLive"
        />
      </AnalyticsPanel>
    );
  };

  render() {
    const { loading, data, errorMessage } = this.state;
    const activeUsers = (data && data.metrics && data.metrics.activeUsers) || 0;
    const generatedAt = data && data.generatedAt
      ? moment(data.generatedAt).tz(TZ).format('L LT')
      : null;

    return (
      <div className="analytics-page margin-top-20">
        <div className="btn-group" role="group" aria-label={I18n.t('analyticsRefresh')}>
          <button
            className="btn btn-primary"
            type="button"
            disabled={loading}
            onClick={this.fetchLive}
          >
            <Translate value="analyticsRefresh" />
          </button>
        </div>

        {loading && !data && (
          <p className="margin-top-20">
            <Translate value="analyticsLoading" />
          </p>
        )}

        {errorMessage && (
          <p className="color-red margin-top-20">{errorMessage}</p>
        )}

        {data && (
          <Fragment>
            {!data.error && (
              <div className="analytics-live-hero margin-top-20">
                <AnalyticsKpiGrid
                  items={[{
                    key: 'activeUsers',
                    labelKey: 'analyticsActiveUsers',
                    value: activeUsers,
                    tone: 'blue',
                  }]}
                />
              </div>
            )}

            {generatedAt && (
              <div className="analytics-meta">
                <span>
                  {I18n.t('analyticsUpdatedAt')}
                  {': '}
                  {generatedAt}
                </span>
                {data.cached && (
                  <span className="badge badge-secondary">
                    <Translate value="analyticsCached" />
                  </span>
                )}
              </div>
            )}

            {!data.error && this.renderTopPages(data.topPages)}
          </Fragment>
        )}
      </div>
    );
  }
}

export default LiveTab;
